<template>
  <van-dialog
    v-model="visible"
    confirm-button-text="我知道啦"
    >
      <div class="content-wrapper-outer">
        <div class="content-wrapper" v-for="item in topicInfo.topic_list" :key="item.id">
        <div class="title">{{item.title}}</div>
        <div class="sub-title" v-if="topicInfo.group_name">{{topicInfo.group_name}}</div>
        <div class="content">{{item.description}}</div>
      </div>
    </div>
  </van-dialog>
</template>
<script>
export default {
  props: {
    topicInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      visible: false
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .van-dialog__header {
  padding-top: 12px;
  font-size: 17px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #333;
}

/deep/ .van-dialog__footer {
  justify-content: center;
  padding: 0;
}

/deep/ .van-button {
  flex: inherit;
  width: 188px;
  height: 40px;
  margin-top: 12px;
  margin-bottom: 12px;
  color: #fff;
  background: #e02727;
  border-radius: 20px;
}

/deep/ .van-hairline--top {
  &::after {
    border: 0;
  }
}

.content-wrapper {
  padding: 4px 14px;
  text-align: center;

  .title {
    height: 17px;
    margin-top: 12px;
    font-size: 17px;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 17px;
    color: #333;
  }

  .sub-title {
    padding: 10px 0;
    font-size: 13px;
    font-weight: 400;
    color: #333;
  }

  .content {
    padding: 0 10px 14px;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    color: #666;
  }
}

/deep/ .content-wrapper-outer {
  max-height: 300px;
  overflow-y: auto;
}

::-webkit-scrollbar {
  /* 隐藏滚轮 */
  display: none;
}
</style>
